import React, { useEffect, useState } from "react";
import { Star, ThumbsUp } from "lucide-react";
import api, { formatError } from "@/lib/api";
import Seo from "@/components/Seo";
import { toast } from "sonner";

function Stars({ value, onChange, label }) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-sm font-medium text-gray-700">{label}</span>
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" onClick={() => onChange(n)} data-testid={`${label}-star-${n}`}>
            <Star className={`w-6 h-6 ${n <= value ? "fill-[#E0243A] text-[#E0243A]" : "text-gray-300"}`} />
          </button>
        ))}
      </div>
    </div>
  );
}

export default function Feedback() {
  const [branches, setBranches] = useState([]);
  const [f, setF] = useState({ branch_id: "", food: 5, service: 5, cleanliness: 5, overall: 5, comment: "" });
  const [result, setResult] = useState(null);

  useEffect(() => { api.get("/branches").then((r) => { setBranches(r.data); if (r.data.length) setF((p) => ({ ...p, branch_id: r.data[0].id })); }); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/feedback", f); setResult(data); }
    catch (err) { toast.error(formatError(err.response?.data?.detail)); }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
      <Seo title="Feedback – HELIUM" description="Deine Meinung zählt. Bewerte deinen HELIUM Besuch." />
      <span className="text-xs font-semibold uppercase tracking-wider text-[#E0243A]">Feedback</span>
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mt-2 font-display">Wie war dein Besuch?</h1>

      {result ? (
        <div className="mt-8 bg-white rounded-2xl border border-gray-100 p-8 shadow-sm text-center" data-testid="feedback-result">
          {result.positive ? (
            <>
              <ThumbsUp className="w-12 h-12 mx-auto text-[#E0243A]" />
              <h2 className="text-xl font-bold mt-4">Vielen Dank!</h2>
              <p className="text-gray-600 mt-2">Möchtest du deine Erfahrung auf Google teilen?</p>
              {result.google_review_url && <a href={result.google_review_url} target="_blank" rel="noreferrer" data-testid="google-review-link" className="mt-5 inline-block bg-[#E0243A] text-white font-semibold px-6 py-3 rounded-xl">Google Bewertung abgeben</a>}
            </>
          ) : (
            <>
              <h2 className="text-xl font-bold">Es tut uns leid.</h2>
              <p className="text-gray-600 mt-2">Danke für dein ehrliches Feedback. Wir kümmern uns darum, was wir verbessern können.</p>
            </>
          )}
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 bg-white rounded-2xl border border-gray-100 p-6 shadow-sm space-y-5">
          <select value={f.branch_id} onChange={(e) => setF({ ...f, branch_id: e.target.value })} data-testid="feedback-branch" className="w-full px-4 py-3 rounded-xl border border-gray-200">
            {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
          <Stars label="Essen" value={f.food} onChange={(v) => setF({ ...f, food: v })} />
          <Stars label="Service" value={f.service} onChange={(v) => setF({ ...f, service: v })} />
          <Stars label="Sauberkeit" value={f.cleanliness} onChange={(v) => setF({ ...f, cleanliness: v })} />
          <Stars label="Gesamt" value={f.overall} onChange={(v) => setF({ ...f, overall: v })} />
          <textarea placeholder="Kommentar (optional)" rows={3} value={f.comment} onChange={(e) => setF({ ...f, comment: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-gray-200" data-testid="feedback-comment" />
          <button data-testid="feedback-submit" className="w-full bg-[#E0243A] hover:bg-[#C81E33] text-white font-semibold py-3 rounded-xl">Bewertung absenden</button>
        </form>
      )}
    </div>
  );
}
